/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_Revoke_Error_TitleInputs */

const es_user_profile_devices_revoke_error_title = /** @type {(inputs: User_Profile_Devices_Revoke_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al revocar`)
};

const en_user_profile_devices_revoke_error_title = /** @type {(inputs: User_Profile_Devices_Revoke_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to revoke device`)
};

/**
* | output |
* | --- |
* | "Failed to revoke device" |
*
* @param {User_Profile_Devices_Revoke_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_revoke_error_title = /** @type {((inputs?: User_Profile_Devices_Revoke_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_Revoke_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_revoke_error_title(inputs)
	return en_user_profile_devices_revoke_error_title(inputs)
});
export { user_profile_devices_revoke_error_title as "user.profile.devices.revoke.error_title" }